import { SimpleSwitchField } from "containers/Resources/screens/ResourcesSingle/components/ResourceDetails/SimpleSwitchField";

export const TrackInGitField = ({
    defaultValue,
    initialValue,
    onChange,
    label,
    isDisabled,
}: {
    onChange?: (e?: any) => void;
    defaultValue?: boolean;
    initialValue?: boolean;
    label?: string;
    isDisabled?: boolean;
}) => (
    <SimpleSwitchField
        name="track_in_git"
        defaultValue={defaultValue}
        initialValue={initialValue}
        onChange={onChange}
        label={label}
        isDisabled={isDisabled}
    />
);
